export const RegisterPermissions = ['public_profile', 'email'];

export default RegisterPermissions;
